import { buildRestUrl, buildAuthHeadersForFetch } from "@services/RestService";
import RestEndpointsEnum from "@models/RestEndpointsEnum";
import IUserUI from "@models/IUserUI";
import ISupplierModel from "@models/ISupplierModel";
import IVendorModel from "@models/IVendorModel";

/**
 * Downloads a processed report's generated Excel file via the authenticated REST endpoint
 * (/v1/reports/:reportGuid/excel). The file is streamed/signed server-side, so it must be
 * fetched with auth headers rather than opened directly from excel_file_url.
 */
const downloadExcelReport = async (
    reportGuid: string,
    userModel: IUserUI,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<void> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ReportsDownloadExcelReport,
        params: { reportGuid },
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
        includeContentType: false,
    });

    const response = await fetch(url, { method: "GET", headers });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || `HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    // Prefer the server-provided filename from Content-Disposition, else fall back.
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = `report-${reportGuid}.xlsx`;
    const match = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match?.[1]) {
        filename = match[1].replace(/['"]/g, "");
    }

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
};

export default { downloadExcelReport };
